import { useQuery } from "react-query";
import { getToken } from "../components/helpers/tokenAquirer";
import { useMsal, useAccount } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export function useTokenQuery() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  return useQuery("token", () => getToken(instance, account, inProgress), {
    enabled: !!account && inProgress === "none",
    retry: 1,
    onError: () => {
      // Silent acquisition failed after retries — redirect to login
      instance.loginRedirect(loginRequest).catch(console.error);
    },
  });
}
